import { Injectable } from '@angular/core';

/**
 * Manages z-index values for overlay components (dialogs, bottom sheets).
 * Each call to `next()` returns a value higher than the previous, ensuring
 * that overlays opened later always stack on top of earlier ones.
 */
@Injectable({ providedIn: 'root' })
export class OverlayZIndexService {
  private counter = 0;
  readonly base = 1000;

  next(): number {
    return this.base + ++this.counter * 10;
  }
}
